<template>
    <div>
        <Row :gutter="16">
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Row>
                    <Col>
                        <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                              ref="form">
                            <Row>
                                <Col>
                                    <FormItem :label="t.pic.name" prop="name">
                                        <Input v-model="formItem.name" :maxlength="20"
                                               :placeholder="msgUtil.placeholderRequired(t.pic.name)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.pic.thumb" prop="thumb">
                                        <Input v-model="formItem.thumb">
                                            <Button slot="append" type="success"
                                                    @click="openImageModal(1, formItem.thumb)">
                                                {{msgUtil.message.action.picSelect}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                    <FormItem :label="t.pic.image" prop="image">
                                        <Input v-model="formItem.image">
                                            <Button slot="append" type="success"
                                                    @click="openImageModal(0, formItem.image)">
                                                {{msgUtil.message.action.picSelect}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                    <FormItem :label="t.pic.sortOrder" prop="sortOrder">
                                        <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                    </FormItem>
                                    <FormItem :label="t.pic.status" prop="status">
                                        <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                            <span slot="open">{{t.pic.open}}</span>
                                            <span slot="close">{{t.pic.close}}</span>
                                        </i-switch>
                                    </FormItem>
                                    <FormItem :label="t.pic.description" prop="description">
                                        <Input v-model="formItem.description" :maxlength="200"
                                               :placeholder="msgUtil.placeholderRequired(t.pic.description)"
                                               type="textarea"></Input>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span="8">
                                    <FormItem>
                                        <Button type="primary" :loading="loading" @click="handleSubmit()">
                                            {{msgUtil.message.action.submit}}
                                        </Button>
                                        <Button @click="handleReset()" style="margin-left: 8px">
                                            {{msgUtil.message.action.reset}}
                                        </Button>
                                    </FormItem>
                                </Col>
                                <Col span="16">
                                    <span style="float: right;">
                                         <div class="pic-upload-list" v-if="formItem.image != null">
                                            <img :src="formItem.image"/>
                                            <div class="pic-upload-list-cover">
                                                <Icon type="ios-eye-outline" @click="openPreviewImageModal(0)"></Icon>
                                            </div>
                                        </div>
                                        <div class="img-drag" v-else>
                                            <div style="width: 58px;height:58px;line-height: 58px;">
                                                <Icon type="ios-camera" size="20"></Icon>
                                            </div>
                                        </div>
                                        <div class="pic-upload-list" v-if="formItem.thumb != null">
                                            <img :src="formItem.thumb"/>
                                            <div class="pic-upload-list-cover">
                                                <Icon type="ios-eye-outline" @click="openPreviewImageModal(1)"></Icon>
                                            </div>
                                        </div>
                                        <div class="img-drag" v-else>
                                            <div style="width: 58px;height:58px;line-height: 58px;">
                                                <Icon type="ios-camera" size="20"></Icon>
                                            </div>
                                        </div>
                                    </span>
                                    <Modal v-model="previewImageModal" :width="previewImageModalWidth">
                                        <img :src="previewImage" style="max-width:100%;max-height:100%;">
                                        <div slot="footer">
                                            {{formItem.previewImageName}}
                                        </div>
                                    </Modal>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </Row>
        <Modal
            :title='msgUtil.message.action.changePic'
            v-model="imageModal"
            :mask="true"
            :footer-hide="true"
            :mask-closable="false"
            :width="imageModalWidth">
            <Row>
                <div class="sub-cropper">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.outputSize"
                        :outputType="option.outputType"
                        :info="option.info"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :fixedBox="option.fixedBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :centerBox="option.centerBox"
                        :high="option.high"
                        :infoTrue="option.infoTrue"
                        @realTime="realTime"
                        @imgLoad="imgLoad"
                        @cropMoving="cropMoving"
                        :enlarge="option.enlarge"
                    ></vueCropper>
                </div>
            </Row>
            <Row>
                <Col style="text-align:right;">
                    <Upload action="image/jpeg" :before-upload="handleBeforeUpload"
                            style="display:inline-block;margin-right: 10px;">
                        <Button icon="ios-cloud-upload-outline">
                            {{msgUtil.message.action.picSelect}}
                        </Button>
                    </Upload>
                    <Button v-if="option.img != null && option.img !== ''" type="primary" @click="handleUpload">
                        {{msgUtil.message.action.upload}}
                    </Button>
                    <Button v-else type="primary" disabled>
                        {{msgUtil.message.action.upload}}
                    </Button>
                </Col>
            </Row>
        </Modal>
    </div>
</template>

<script>
import BaseUrl from '_conf/url';
import { edit, getImageSizeInfo, getPicInfo } from '@/api/pic';
import { VueCropper } from 'vue-cropper';
import { uploadImg } from '@/api/image';

export default {
    name: 'content_pic_edit',
    components: {
        VueCropper,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            baseURL: BaseUrl.dataUrl + 'image/hd/',
            option: {
                img: '',
                outputSize: 1,
                //输出图片格式
                outputType: 'png',
                info: true,
                //截图信息展示是否是真实的输出宽高
                infoTrue: true,
                //是否输出原图比例的截图
                full: false,
                //能否拖动图片
                canMove: true,
                //能否拖动截图框
                canMoveBox: true,
                //截图框固定大小
                fixedBox: true,
                //上传图片是否显示原始宽高 (针对大图 可以铺满)
                original: false,
                //是否自动生成截图框
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 0,
                autoCropHeight: 0,
                //截图框是否限制在图片里(只有在自动生成截图框时才能生效)
                centerBox: false,
                //是否根据dpr生成适合屏幕的高清图片
                high: true,
                //是否按照截图框比例输出 默认为1
                enlarge: 1,
                cropData: {},
            },
            imageModal: false,
            previewImageModal: false,
            previewImage: null,
            previewImageWidth: 0,
            imageSizeList: [],
            formItemBk: {},
            formItem: {
                name: '', //图片名
                image: null,
                thumb: null,
                sortOrder: 0,
                status: '1',
                description: '', //图片详细 //图片URL
                type: '1', //0サムネイル、１普通画像、2音声３、ビデオ４、スライドショー（幻灯片）
                imageSizeIndex: -1,
                imageSizeType: '',
            },
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.pic.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 20,
                        message: msgUtil.errorMaxLengthFullWidth(t.pic.name, 20),
                        trigger: 'blur',
                    },
                ],
                thumb: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.pic.thumb),
                        trigger: 'blur',
                    },
                ],
                image: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.pic.image),
                        trigger: 'blur',
                    },
                ],
                description: [
                    {
                        type: 'string',
                        max: 200,
                        message: msgUtil.errorMaxLengthFullWidth(t.pic.description, 200),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
        };
    },
    computed: {
        imageModalWidth() {
            let width = this.option.autoCropWidth + 100;
            return width < 600 ? 600 : width;
        },
        previewImageModalWidth() {
            return this.previewImageWidth;
        },
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    let picDto = {};
                    picDto.name = this.formItem.name;
                    picDto.thumb = this.formItem.thumb;
                    picDto.image = this.formItem.image;
                    picDto.sortOrder = this.formItem.sortOrder;
                    picDto.status = this.formItem.status;
                    picDto.description = this.formItem.description;
                    picDto.type = this.formItem.type;
                    await edit(this.$route.params.id, picDto);
                    Object.assign(this.formItemBk, this.formItem);
                    this.$Loading.finish();
                    this.$Message.success(this.msgUtil.message.action.updateSuccess);
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.updateFail);
                }
                this.loading = false;
            });
        },
        handleReset() {
            this.$refs.form.resetFields();
            Object.assign(this.formItem, this.formItemBk);
            this.loading = false;
        },
        //图片预览
        openPreviewImageModal(index) {
            const imageSizeInfo = this.imageSizeList[index];
            if (imageSizeInfo.range === 'image') {
                this.previewImage = this.formItem.image;
                this.formItem.previewImageName = this.t.pic.image;
            } else if (imageSizeInfo.range === 'thumb') {
                this.previewImage = this.formItem.thumb;
                this.formItem.previewImageName = this.t.pic.thumb;
            }
            let width = parseInt(imageSizeInfo.width) + 32;
            this.previewImageWidth = width < 100 ? 105 : width;
            this.previewImageModal = true;
        },
        //图片裁剪
        openImageModal(index, url) {
            const imageSizeInfo = this.imageSizeList[index];
            if (imageSizeInfo.range === 'image') {
                this.option.img = this.formItem.image;
                this.formItem.imageType = 'image';
            } else if (imageSizeInfo.range === 'thumb') {
                this.option.img = this.formItem.thumb;
                this.formItem.imageType = 'thumb';
            }
            this.option.img = url;
            this.option.autoCropWidth = parseInt(imageSizeInfo.width);
            this.option.autoCropHeight = parseInt(imageSizeInfo.height);
            this.$refs.cropper.changeCrop(this.option.autoCropWidth, this.option.autoCropHeight);
            this.imageModal = true;
        },
        handleBeforeUpload(file) {
            //上传图片
            if (!/^image/.test(file.type) || !/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
                this.$Notice.warning({
                    title: this.msgUtil.message.file.error.format,
                    desc:
                        this.msgUtil.message.file.name +
                        '{' +
                        file.name +
                        '}' +
                        this.msgUtil.message.file.error.typeFormat,
                    duration: 15,
                });
                return false;
            }
            const reader = new FileReader();
            reader.onload = e => {
                let data;
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                this.option.img = data;
            };

            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blob
            reader.readAsArrayBuffer(file);
            return false;
        },
        // 实时预览函数
        realTime(data) {
            //console.log(data);
        },
        handleUpload() {
            this.$refs.cropper.getCropBlob(data => {
                //var blobObject = new Blob([data]);
                const formData = new FormData();
                formData.append('image', data);
                uploadImg(formData).then(d => {
                    if (this.formItem.imageType === 'image') {
                        this.formItem.image = BaseUrl.Url + d.url;
                    } else if (this.formItem.imageType === 'thumb') {
                        this.formItem.thumb = BaseUrl.Url + d.url;
                    }
                    this.imageModal = false;
                });
            });
        },
        imgLoad(msg) {
            //console.log(msg);
        },
        cropMoving(data) {
            this.option.cropData = data;
        },
        async init() {
            //得到图片大小情报
            const imageSizeInfo = await getImageSizeInfo();
            if (imageSizeInfo.imageSizeList != null) {
                this.imageSizeList = imageSizeInfo.imageSizeList;
            }

            const picInfo = await getPicInfo(this.$route.params.id);
            if (picInfo.picture != null) {
                this.formItem = picInfo.picture;
                this.formItem.imageType = '';
                this.formItem.previewImageName = '';
            }
            Object.assign(this.formItemBk, picInfo.picture);
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.sub-cropper {
    height: 600px;
    margin-bottom: 10px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1080px) {
    .sub-cropper {
        height: 600px;
    }
}
</style>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    /*cursor: pointer;*/
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    display: inline-block;
    width: 58px;
    height: 58px;
    margin-left: 10px;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.sub-cropper {
    height: 600px;
    margin-bottom: 10px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1080px) {
    .sub-cropper {
        height: 600px;
    }
}

.pic-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}

.pic-upload-list img {
    width: 100%;
    height: 100%;
}

.pic-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.pic-upload-list:hover .pic-upload-list-cover {
    display: block;
}

.pic-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
